import { useCallback, useEffect, useState, useTransition } from "react";
import { useSearchParams } from "react-router-dom";
import {
  RO_DETAIL_QUERY_OPEN,
  RO_DETAIL_QUERY_RO,
  RO_DETAIL_QUERY_ID,
} from "../data/inRepairRoDetailConstants";

const useRoDetailModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [pendingOpenRoId, setPendingOpenRoId] = useState(null);
  const [isClosePending, setIsClosePending] = useState(false);
  const [isPending, startTransition] = useTransition();

  const roNumber = searchParams.get(RO_DETAIL_QUERY_RO) || "";
  const roId = searchParams.get(RO_DETAIL_QUERY_ID) || "";
  const openRoParam = searchParams.get(RO_DETAIL_QUERY_OPEN);
  const isOpen =
    openRoParam != null &&
    openRoParam !== "" &&
    Boolean(roNumber) &&
    Boolean(roId);

  const clearQueryParams = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(RO_DETAIL_QUERY_OPEN);
        next.delete(RO_DETAIL_QUERY_RO);
        next.delete(RO_DETAIL_QUERY_ID);
        return next;
      },
      { replace: true }
    );
  }, [setSearchParams]);

  useEffect(() => {
    if (!isPending) {
      setPendingOpenRoId(null);
      setIsClosePending(false);
    }
  }, [isPending]);

  const openRoDetail = useCallback(
    ({ id, ro_number: ro, open_ro_count: openRoCount } = {}) => {
      if (!id || !ro) return;

      const openRoValue =
        openRoCount != null && openRoCount !== "" ? openRoCount : 1;

      setIsClosePending(false);
      setPendingOpenRoId(id);
      startTransition(() => {
        setSearchParams(
          (prev) => {
            const next = new URLSearchParams(prev);
            next.set(RO_DETAIL_QUERY_OPEN, String(openRoValue));
            next.set(RO_DETAIL_QUERY_RO, String(ro));
            next.set(RO_DETAIL_QUERY_ID, String(id));
            return next;
          },
          { replace: false }
        );
      });
    },
    [setSearchParams]
  );

  const closeRoDetail = useCallback(() => {
    setPendingOpenRoId(null);
    setIsClosePending(true);
    startTransition(() => {
      clearQueryParams();
    });
  }, [clearQueryParams]);

  return {
    isOpen,
    roNumber,
    roId,
    pendingOpenRoId: isPending ? pendingOpenRoId : null,
    isClosePending: isPending && isClosePending,
    openRoDetail,
    closeRoDetail,
  };
};

export default useRoDetailModal;
